export default __webpack_public_path__ + "static/media/srd.30239779.gif";